import React, { useEffect, useState } from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const CArticuloMuebleEmpresa = () => {
  const [auxiliares, setAuxiliares] = useState({ materiales: [], tipos: [], colores: [] });

  useEffect(() => {
    const fetchAuxiliares = async () => {
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/mueble/auxiliares`);
        const data = await res.json();
        setAuxiliares(data);
      } catch (error) {
        console.error('Error al cargar datos auxiliares de mueble:', error);
      }
    };
    fetchAuxiliares();
  }, []);

  return (
    <>
      <Form.Item name="material" label="Material">
        <Select placeholder="Seleccione un material">
          {auxiliares.materiales.map(m => (
            <Option key={m.mat_id} value={m.mat_nombre}>{m.mat_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="dimensiones" label="Dimensiones">
        <Input />
      </Form.Item>

      <Form.Item name="tipo_mueble" label="Tipo de Mueble">
        <Select placeholder="Seleccione un tipo">
          {auxiliares.tipos.map(t => (
            <Option key={t.tip_id} value={t.tip_nombre}>{t.tip_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="color" label="Color">
        <Select placeholder="Seleccione un color">
          {auxiliares.colores.map(c => (
            <Option key={c.col_id} value={c.col_nombre}>{c.col_nombre}</Option>
          ))}
        </Select>
      </Form.Item>

      <Form.Item name="peso_soportado" label="Peso Soportado">
        <Input />
      </Form.Item>
    </>
  );
};

export default CArticuloMuebleEmpresa;